import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ShopOutlinedSvg from "@ant-design/icons-svg/es/asn/ShopOutlined";
import AntdIcon from "../components/AntdIcon";
var ShopOutlined = function ShopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShopOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ShopOutlined.displayName = 'ShopOutlined';
}
export default /*#__PURE__*/React.forwardRef(ShopOutlined);